<mat-sidenav-container hasBackdrop="true">
    <mat-sidenav #sidenav mode="over" class="job-detail-drawer xl" position="end" [fixedInViewport]="true"
        [disableClose]="true" [opened]="true">
        <button class="drawer-close-btn mat-elevation-z0" (click)="goBack()" mat-mini-fab aria-label="Close">
            <mat-icon>close</mat-icon>
        </button>
        <mat-tab-group class="common-tabs" [selectedIndex]="0" #tabGroup>
            <mat-tab label="Asset Details">
                <ng-template matTabContent>
                    <app-asset-detail [assetDataID]="selectedAssetId" [assetStatus]="assetStatus">            
                    </app-asset-detail>
                </ng-template>
            </mat-tab>
             <mat-tab label="Duplicate Asset" *ngIf="assetStatusCategoriesEnum[assetStatus] == assetStatusCategoriesEnum.Duplicated">
                <ng-template matTabContent>      
                    <app-asset-detail-compare  [assetDataID]="selectedAssetId">
                    </app-asset-detail-compare>
                </ng-template>
            </mat-tab> 
        </mat-tab-group>
    </mat-sidenav>
    <mat-sidenav-content>
    </mat-sidenav-content>
</mat-sidenav-container>